import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';
import { signIn } from '@/lib/auth-client';


export function Register() {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  // Keep these functions for future re-enablement of email signup
  // const validateForm = () => { ... }
  // const handleEmailChange = (e) => { ... }
  // const handleSubmit = async (e) => { ... }

  if (success) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl">Registration Successful!</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-center text-green-600">
              Welcome! Your account has been created successfully.
            </p>
            <p className="text-center mt-2">
              Redirecting to dashboard...
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl text-center">Create an account</CardTitle>
          <CardDescription className="text-center">
            Enter your details to get started
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            {/* Registration is limited to Google only */}
            <Button
              type="button"
              className="w-full"
              variant="outline"
              onClick={async () => {
                try {
                  // Use better-auth client for OAuth signup
                  await signIn.social({
                    provider: 'google',
                    callbackURL: '/auth/callback' // Redirect to frontend callback handler
                  });
                } catch (error) {
                  console.error("Google signup failed:", error);
                  setError("Failed to initiate Google signup. Please try again.");
                }
              }}
            >
              Sign up with Google
            </Button>

            {/* NOTE: GitHub and LINE signup are intentionally disabled. Users can register via Google only, but can login with any method after registration. */}
            {/* TODO: Re-enable GitHub and LINE signup options if needed */}
            {/* <Button
              type="button"
              className="w-full"
              variant="outline"
              onClick={async () => {
                try {
                  // Use better-auth client for GitHub OAuth signup
                  await signIn.social({
                    provider: 'github',
                    callbackURL: '/console' // Redirect to console after signup
                  });
                } catch (error) {
                  console.error("GitHub signup failed:", error);
                  setError("Failed to initiate GitHub signup. Please try again.");
                }
              }}
            >
              Sign up with GitHub
            </Button>
            <Button
              type="button"
              className="w-full"
              variant="outline"
              onClick={async () => {
                try {
                  // Use better-auth client for LINE OAuth signup
                  await signIn.social({
                    provider: 'line',
                    callbackURL: '/console' // Redirect to console after signup
                  });
                } catch (error) {
                  console.error("LINE signup failed:", error);
                  setError("Failed to initiate LINE signup. Please try again.");
                }
              }}
            >
              Sign up with LINE
            </Button> */}
          </div>

          {/* TODO: Re-enable email signup form */}
          {/* <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <span className="w-full border-t" />
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-background px-2 text-muted-foreground">
                  Or continue with
                </span>
              </div>
            </div> */}

          {/* TODO: Re-enable email signup form */}
          {/* <form onSubmit={handleSubmit} className="space-y-4 mt-4">
            <div className="space-y-2">
              <Label htmlFor="name">Full Name</Label>
              <Input
                id="name"
                type="text"
                placeholder="John Doe"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="name@company.com"
                value={email}
                onChange={handleEmailChange}
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <div className="relative">
                <Input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeOff className="h-4 w-4 text-gray-500" />
                  ) : (
                    <Eye className="h-4 w-4 text-gray-500" />
                  )}
                </button>
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="confirmPassword">Confirm Password</Label>
              <div className="relative">
                <Input
                  id="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <EyeOff className="h-4 w-4 text-gray-500" />
                  ) : (
                    <Eye className="h-4 w-4 text-gray-500" />
                  )}
                </button>
              </div>
            </div>

            {error && (
              <Alert variant="destructive">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}

            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? 'Creating Account...' : 'Create Account'}
            </Button>
          </form> */}
          
          <div className="mt-4 text-center text-sm">
            Already have an account?{' '}
            <a href="/login" className="font-medium text-primary hover:underline">
              Sign in
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default Register;